// extracted by mini-css-extract-plugin
export default {"groupbar":"SectionMenu_groupbar__9Ebwg"};